import { PartnerFeatureFlags } from 'types/PartnerAccountSettings'
import usePartnerAccountSettings from './usePartnerAccountSettings'

const usePartnerFeatureFlags = (): PartnerFeatureFlags => {
  const { featureFlags } = usePartnerAccountSettings()
  return featureFlags
}

export default usePartnerFeatureFlags
